/**
 * Check if a user is likely logged in by checking local storage
 *
 * This is a simpler approach that doesn't rely on API calls.
 * We use localStorage to store a flag when the user logs in,
 * and check for this flag instead of making an API call.
 *
 * @returns {Promise<boolean>} - Promise resolving to true if user is likely logged in
 */
export const isUserLoggedIn = async () => {
    // Check if there's any login-related item in localStorage
    // This is a non-sensitive indicator that login might have happened
    // We don't store any sensitive data here, just a flag
    const hasLoginIndicator = localStorage.getItem("userLoggedIn") === "true";

    return hasLoginIndicator;
};
